import { useContext } from 'react'
import { ApiContext, CheckoutContext, CompanyContext } from '../@contexts'

export const useApi = () => useContext(ApiContext)
export const useCheckout = () => useContext(CheckoutContext)
export const useCompany = () => useContext(CompanyContext)
